/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ entry_lib; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// CONCATENATED MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject = require("vue");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject);
;// CONCATENATED MODULE: ./src/components/NavBar/Components/Launcher.tsx


/* harmony default export */ var Launcher = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    open: {
      type: Boolean,
      required: true
    },
    toggleOpen: {
      type: Function,
      required: true
    },
    launcherApplications: {
      type: Array,
      // eslint-disable-next-line
      default: [],
      required: false
    },
    launcherDiscoverApplications: {
      type: Array,
      // eslint-disable-next-line
      default: [],
      required: false
    },
    launcherStaffTools: {
      type: Array,
      // eslint-disable-next-line
      default: [],
      required: false
    },
    clickLauncherApplication: {
      type: Function,
      required: true
    },
    user: {
      type: Object
    }
  },
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "application-launcher",
      "on": {
        "click": () => this.toggleOpen('launcher')
      }
    }, [h("i", {
      "attrs": {
        "id": "applicationLauncherIcon"
      },
      "class": "fas fa-th tgb-fa-icon"
    }), this.open && h("div", {
      "class": "application-launcher-dropdown"
    }, [h("p", {
      "class": "application-launcher-dropdown-title"
    }, ["Apps"]), this.launcherApplications && this.launcherApplications.map(app => {
      return h("div", {
        "attrs": {
          "id": app.name,
          "data-test": app.dataTest
        },
        "class": "launcher-application",
        "on": {
          "click": () => this.clickLauncherApplication(app)
        }
      }, [h("img", {
        "attrs": {
          "src": app.icon
        },
        "class": "launcher-application-icon"
      }), app.name]);
    }), h("p", {
      "class": "application-launcher-dropdown-title"
    }, ["Discover"]), this.launcherDiscoverApplications && this.launcherDiscoverApplications.map(app => {
      return h("div", {
        "attrs": {
          "id": app.name,
          "data-test": app.dataTest
        },
        "class": "launcher-application",
        "on": {
          "click": () => this.clickLauncherApplication(app)
        }
      }, [h("img", {
        "attrs": {
          "src": app.icon
        },
        "class": "launcher-application-icon"
      }), app.name]);
    }), this.user?.groups?.includes('staff') && this.launcherStaffTools && this.launcherStaffTools.map(app => {
      return h("div", [h("p", {
        "class": "application-launcher-dropdown-title"
      }, ["Staff Tools"]), h("div", {
        "attrs": {
          "id": app.name,
          "data-test": app.dataTest
        },
        "class": "launcher-application",
        "on": {
          "click": () => this.clickLauncherApplication(app)
        }
      }, [h("img", {
        "attrs": {
          "src": app.icon
        },
        "class": "launcher-application-icon"
      }), app.name])]);
    })])]);
  }
}));
;// CONCATENATED MODULE: ./src/components/NavBar/Components/AccountDropdown.tsx


/* harmony default export */ var AccountDropdown = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    open: {
      type: Boolean,
      required: true
    },
    toggleOpen: {
      type: Function,
      required: true
    },
    user: {
      type: Object
    },
    defaultAvatar: {
      required: true
    },
    domain: String
  },
  render() {
    const h = arguments[0];
    const domain = this.domain || 'tagboard.com';
    const handleClickSignOut = () => {
      window.open(`https://user.${domain}/logout`, '_self');
    };
    // eslint-disable-next-line
    const handleBrokenImage = event => {
      event.target.classList.toggle("avatar-placeholder");
      event.target.src = this.defaultAvatar;
    };
    return h("div", [this.user ? h("div", {
      "style": {
        position: 'relative'
      },
      "class": "account-dropdown"
    }, [h("img", {
      "attrs": {
        "id": "accountDropdownIcon",
        "alt": "account-dropdown",
        "title": this.user.displayName,
        "src": this.user.avatar ?? this.defaultAvatar
      },
      "class": 'account-dropdown-icon' + (this.user.avatar ? '' : ' avatar-placeholder'),
      "on": {
        "error": handleBrokenImage,
        "click": () => this.toggleOpen('account')
      }
    }), this.open && h("div", {
      "class": "account-dropdown-menu"
    }, [h("div", {
      "class": "account-dropdown-item account-dropdown-item-user"
    }, [h("span", {
      "class": "account-dropdown-menu-title"
    }, ["Signed in as"]), h("span", [this.user.displayName]), h("span", [this.user.email])]), h("span", {
      "class": "account-dropdown-divider"
    }), h("div", {
      "attrs": {
        "id": "signOutLink"
      },
      "class": "account-dropdown-item sign-out",
      "on": {
        "click": handleClickSignOut
      }
    }, ["Sign Out"])])]) : h("div", {
      "class": "sign-in-btn"
    }, [h("button", ["Sign In"])])]);
  }
}));
;// CONCATENATED MODULE: ./src/components/NavBar/NavBar.tsx




/* harmony default export */ var NavBar = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    icon: String,
    title: {
      type: String
    },
    activeTab: String,
    navLinks: {
      type: Array
    },
    navIcons: {
      type: Array
    },
    launcherApplications: {
      type: Array,
      required: false
    },
    launcherDiscoverApplications: {
      type: Array,
      required: false
    },
    launcherStaffTools: {
      type: Array,
      required: false
    },
    user: {
      type: Object
    },
    defaultAvatar: {
      required: true
    },
    classes: String,
    domain: String
  },
  data() {
    return {
      launcherOpen: false,
      accountOpen: false,
      windowWidth: window.innerWidth,
      taglandiaUrl: `https://app.${this.domain}`
    };
  },
  methods: {
    toggleOpen(menuName) {
      this.launcherOpen = menuName === 'launcher' ? this.launcherOpen = !this.launcherOpen : false;
      this.accountOpen = menuName === 'account' ? this.accountOpen = !this.accountOpen : false;
    },
    // eslint-disable-next-line
    handleClickOutside(e) {
      // this prevents TypeScript error
      const target = e.target;
      const menuIds = ['applicationLauncherIcon', 'accountDropdownIcon'];
      // checks if the clicked classname matches a menu classname
      const menuClick = menuIds.some(menu => target.id.includes(menu));
      //closes all menus if a menu wasn't clicked
      if (!menuClick) this.toggleOpen('');
    },
    async optInThenRedirect() {
      const url = `https://user.${this.domain}/opt-in`;
      const body = {
        data: {
          action: 'completed',
          user: {
            user_id: this.user.user_id
          }
        }
      };
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(body)
      });
      if (!response.ok) {
        return false;
      }
      window.location.href = this.taglandiaUrl;
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  computed: {
    mobile() {
      return window.innerWidth <= 767;
    }
  },
  render() {
    const h = arguments[0];
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
    const handleClickNavbarBrand = () => {
      this.$emit('click-navbar-brand');
    };
    const handleClickNavigationLink = navLink => {
      this.$emit('click-navbar-link', navLink.title);
    };
    const handleClickNavigationIcon = navIcon => {
      this.$emit('click-navbar-icon', navIcon);
    };
    const handleClickLauncherApplication = application => {
      this.$emit('click-launcher-application', application);
    };
    const renderNavigationLinks = () => {
      return this.navLinks && this.navLinks.map(navLink => h("div", {
        "key": navLink.title,
        "attrs": {
          "id": navLink.title
        },
        "class": `nav-link ${this.activeTab === navLink.title ? 'active' : ''}`,
        "on": {
          "click": () => handleClickNavigationLink(navLink)
        }
      }, [navLink.title]));
    };
    const renderNavigationIcons = () => {
      return this.navIcons && this.navIcons.map(navIcon => h("div", {
        "key": navIcon.id,
        "class": `nav-icon ${navIcon.containerClass}`,
        "on": {
          "click": () => handleClickNavigationIcon(navIcon)
        }
      }, [h("i", {
        "attrs": {
          "id": navIcon.id
        },
        "class": `tgb-fa-icon ${navIcon.iconClass}`
      })]));
    };
    return h("div", {
      "attrs": {
        "id": "tgb-navbar"
      },
      "class": `tgb-navbar ${this.classes}`
    }, [h("div", {
      "class": "navbar-links-container"
    }, [h("div", {
      "class": "nav-icon"
    }, [h(Launcher, {
      "attrs": {
        "open": this.launcherOpen,
        "toggleOpen": this.toggleOpen,
        "launcherApplications": this.launcherApplications,
        "launcherDiscoverApplications": this.launcherDiscoverApplications,
        "launcherStaffTools": this.launcherStaffTools,
        "user": this.user,
        "clickLauncherApplication": handleClickLauncherApplication
      }
    })])]), h("div", {
      "class": "navbar-brand-container",
      "on": {
        "click": handleClickNavbarBrand
      }
    }, [h("img", {
      "attrs": {
        "id": "navbarBrandIcon",
        "alt": "Tagboard logo",
        "src": this.icon
      },
      "class": "navbar-brand-icon"
    }), h("div", {
      "attrs": {
        "id": "navbarBrandTitle"
      },
      "class": "navbar-brand"
    }, [this.$slots.title || this.title])]), this.$slots.default, h("div", {
      "class": "navbar-links-container navbar-links-left underline"
    }, [h("div", {
      "class": "navbar-links"
    }, [renderNavigationLinks()])]), h("div", {
      "class": "navbar-links-container"
    }, [renderNavigationIcons(), h("div", {
      "class": "nav-icon"
    }, [h(AccountDropdown, {
      "attrs": {
        "open": this.accountOpen,
        "toggleOpen": this.toggleOpen,
        "user": this.user,
        "defaultAvatar": this.defaultAvatar,
        "domain": this.domain
      }
    })])])]);
  }
}));
;// CONCATENATED MODULE: ./src/main.ts
// To run locally, you need to import and mount the navbar with vue (uncomment lines 3-12)
// import Vue from 'vue';
// import App from './App.vue';
// import store from './store';
// Vue.config.productionTip = false;
// new Vue({
//   store,
//   render: (h) => h(App),
// }).$mount('#app');
// To export as package, you need to import and export as default (uncomment lines 15-16)

/* harmony default export */ var main = (NavBar);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = (main);


module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=tgb-navbar.common.js.map